export default {"src":"/_next/static/media/money3_white_01.4c2b21d4.svg","height":66,"width":230,"blurWidth":0,"blurHeight":0};